import request from '@/utils/request'

// 取得殺號結果
export const getShJhList_mobile = (lotteryCode, field, form) => {
  const url = '/v1/cp168/wap/recommend/shaHaos'
  const cpCode = lotteryCode
  const params = Object.assign({ cpCode, field }, form)

  return request({
    url,
    params
  })
}
